export const TWILIO_INTEGRATION_PATH = '/api/dashboard/sms-service/user-twilio-account'
export const TWILIO_PHONE_NUMBERS_PATH = '/api/dashboard/sms-service/phone-numbers/list'
